module.exports = __webpack_public_path__ + "b6b8a7faeb0ec2f9f4583fa411cc1e5e.svg";